import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GooglemapService } from './googlemap.service';
import { lastValueFrom } from "rxjs";
import { environment } from '../../environments/environment';
 @Injectable({
  providedIn: 'root'
})
export class ServerconfigService {
  static serviceUrls:any;
  public configKeys: string[];
  public data: any;
  public cnt: number = 0;
  public configId : string = "";
  public idleTime: number;
  constructor(public http?:HttpClient,public gmapService?:GooglemapService) {   
  }
  
    
  loadConfig(): Promise<any> {
    ServerconfigService.serviceUrls = environment;
    if (ServerconfigService.serviceUrls["GOOGLE_API_KEY"] != "") {
      return this.gmapService.loadScript(
        ServerconfigService.serviceUrls["GOOGLE_API_KEY"]
      );
    }
  } 
   getBaseUrl = function(code:string){

   if (code.indexOf(":") !== -1){
      this.configKeys = code.split(":");
      this.data = ServerconfigService.serviceUrls;

      for (this.cnt = 0; this.cnt < this.configKeys.length; this.cnt++) {
        if (this.data.hasOwnProperty(this.configKeys[this.cnt])) {
          this.data = this.data[this.configKeys[this.cnt]];
        }
      }

      return this.data;
   }
   else {
     return ServerconfigService.serviceUrls[code] ? ServerconfigService.serviceUrls[code] : "";   
   }
    
   }   
}